import {
    el, mount, setChildren, setStyle
} from 'redom';
import cloneDeep from 'lodash/cloneDeep';
import { toJpeg } from 'html-to-image';

import { ContentsManager } from '../Content/contentsManager';
import { ContentModel } from '../Content/contentModel';
import { IVariantText } from '../Content/Pattern/Decal/patternText';
import { ConfigurationTranslation } from './configurationTranslation';
import { defaultViews, ToolScreenshot } from '../Tool/toolScreenshot';
import { SystemLayer } from '../System/systemLayer';
import { IArcCameraAngles } from '../System/systemCamera';

import './technical.sass';

export class ConfigurationTechnicalFile {
    private system: SystemLayer;

    private configurationTranslation: ConfigurationTranslation

    private contentsManager: ContentsManager

    private toolScreenshot: ToolScreenshot

    private container: HTMLElement

    // TITLE
    private titlesContainer: HTMLElement

    private logo: HTMLElement

    private orderId: HTMLElement

    private orderDate: HTMLElement

    private orderShippingDate: HTMLElement

    private productSize: HTMLElement

    private productQuantity: HTMLElement

    private productName: HTMLElement

    // IMAGES
    private imagesContainer: HTMLElement

    private imageFront: HTMLImageElement

    private imageLeft: HTMLImageElement

    private imageBack: HTMLImageElement

    // VARIANTS
    private variantsContainer: HTMLElement

    constructor(
        system: SystemLayer,
        configurationTranslation: ConfigurationTranslation,
        toolScreenshot: ToolScreenshot,
        contentsManager: ContentsManager
    ) {
        this.system = system;
        this.configurationTranslation = configurationTranslation;
        this.toolScreenshot = toolScreenshot;
        this.contentsManager = contentsManager;

        this.container = el('div.naker-technical-container', [
            this.titlesContainer = el('div.naker-technical-head', [
                this.logo = el('div.naker-technical-logo'),
                this.orderId = el('div.naker-technical-title.naker-technical-oderid'),
                this.productName = el('div.naker-technical-title.naker-technical-productname'),
                this.productSize = el('div.naker-technical-title.naker-technical-productsize'),
                this.productQuantity = el('div.naker-technical-title.naker-technical-productquantity'),
                this.orderDate = el('div.naker-technical-title.naker-technical-orderdate'),
                this.orderShippingDate = el('div.naker-technical-title.naker-technical-ordershippinddate'),
            ]),
            this.imagesContainer = el('div.naker-technical-images', [
                this.imageFront = el('img.naker-technical-image.naker-technical-front', { crossOrigin: 'anonymous' }) as HTMLImageElement,
                this.imageLeft = el('img.naker-technical-image.naker-technical-left', { crossOrigin: 'anonymous' }) as HTMLImageElement,
                this.imageBack = el('img.naker-technical-image.naker-technical-back', { crossOrigin: 'anonymous' }) as HTMLImageElement,
            ]),
            this.variantsContainer = el('div.naker-technical-variants'),
        ]);
        mount(document.body, this.container);
    }

    // setOrderId(orderId: string) {
    //     this.orderId.textContent = 'ORDER ID: ' + orderId
    // }

    // setProductQuantity(productQuantity: string) {
    //     this.productQuantity.textContent = 'QUANTITY: ' + productQuantity
    // }

    // setProductSize(productSize: string) {
    //     this.productSize.textContent = 'SIZE: ' + productSize
    // }

    // setProductName(productName: string) {
    //     this.productName.textContent = productName
    // }

    // setTitles() {
    //     let dateString = new Date().
    //         toLocaleString('en-us', { year: 'numeric', month: '2-digit', day: '2-digit' }).
    //         replace(/(\d+)\/(\d+)\/(\d+)/, '$3-$1-$2');
    //     this.orderDate.textContent = 'DATE: ' + dateString
    // }

    private langages = ['en']

    public setLangages(langages: string[]): void {
        this.langages = langages;
    }

    public getProductImages(callback: () => void): void {
        setStyle(this.titlesContainer, { display: 'none' });
        setStyle(this.imagesContainer, { display: 'flex' });
        setStyle(this.variantsContainer, { display: 'none' });
        this.setImages(() => {
            this.getJpeg(callback);
        });
    }

    public getProductVariants(callback: () => void): void {
        setStyle(this.titlesContainer, { display: 'none' });
        setStyle(this.imagesContainer, { display: 'none' });
        setStyle(this.variantsContainer, { display: 'flex' });
        this.setVariants();
        this.getJpeg(callback);
    }

    public getProductImagesAndVariants(callback: () => void): void {
        setStyle(this.titlesContainer, { display: 'none' });
        setStyle(this.imagesContainer, { display: 'flex' });
        setStyle(this.variantsContainer, { display: 'flex' });
        this.setVariants();
        this.setImages(() => {
            this.getJpeg(callback);
        });
    }

    public getProductFile(callback: () => void): void {
        setStyle(this.titlesContainer, { display: 'flex' });
        setStyle(this.imagesContainer, { display: 'flex' });
        setStyle(this.variantsContainer, { display: 'flex' });
        // this.setTitles()
        this.setVariants();
        this.setImages(() => {
            this.getJpeg(callback);
        });
    }

    private getJpeg(callback: (image: string) => void) {
        // Iphone Safari only fix is to repeat the action
        if (this.system.getBrowser() === 'Safari') {
            this.loopToJpeg(10, callback);
        } else {
            this.loopToJpeg(1, callback);
        }
    }

    currentLoop = 0

    private loopToJpeg(times, callback: (image: string) => void) {
        setStyle(this.container, { display: 'flex' });
        this.currentLoop = 0;
        this.loopOnceToJpeg(times, (image) => {
            callback(image);
            setStyle(this.container, { display: 'none' });
        });
    }

    private loopOnceToJpeg(times, callback: (image: string) => void) {
        const imageSettings = { quality: 1, pixelRatio: 1 };
        toJpeg(this.container, imageSettings)
            .then((image) => {
                this.currentLoop++;
                this.getPixelImage(image, (hasColor) => {
                    if (hasColor) {
                        callback(image);
                    } else if (this.currentLoop === times) {
                        if (!hasColor) console.error(`Naker: Fail to screenshot technical file after ${times} attempt`);
                        callback(image);
                    } else {
                        // Try again
                        this.loopOnceToJpeg(times, callback);
                    }
                });
            });
    }

    private pixelTestCanvas = document.createElement('canvas');

    private getPixelImage(base64: string, callback: (hasColor: boolean) => void) {
        const image = new Image();
        image.onload = () => {
            const canvas = this.pixelTestCanvas;
            canvas.width = image.width;
            canvas.height = image.height;

            const context = canvas.getContext('2d');
            context.drawImage(image, 0, 0);
            const imageData = context.getImageData(0, 0, canvas.width, canvas.height);

            // Now you can access pixel data from imageData.data.
            // It's a one-dimensional array of RGBA values.
            // Match with technical second image
            // Check Sass file to confirm
            const x = 700 / 2 - 150;
            const y = 700 / 2;
            const index = (y * imageData.width + x) * 4;
            const red = imageData.data[index];
            const green = imageData.data[index + 1];
            const blue = imageData.data[index + 2];
            // const alpha = imageData.data[index + 3];
            if (red !== 255 || green !== 255 || blue !== 255) callback(true);
            else callback(false);
        };
        image.src = base64;
    }

    private views = cloneDeep(defaultViews);

    public setViews(views: IArcCameraAngles[]): void {
        this.views = views;
    }

    private imageLoaded = 0

    private setImages(callback: () => void) {
        const previusSize = this.toolScreenshot.getSize();
        // Too big images are hard to merge on mobile
        const mobileSize = { width: 500, height: 500 };
        const computerSize = { width: 1000, height: 1000 };
        const size = (this.system.isOnMobile) ? mobileSize : computerSize;
        this.toolScreenshot.setSize(size);
        this.toolScreenshot.shotViews(this.views, (views) => {
            this.toolScreenshot.setSize(previusSize);
            this.imageLoaded = 0;
            [this.imageFront.src, this.imageLeft.src, this.imageBack.src] = views;
            //! Need to make sure images are loaded or they won't be on the technical file
            this.imageFront.onload = () => { this.testImageLoad(callback); };
            this.imageLeft.onload = () => { this.testImageLoad(callback); };
            this.imageBack.onload = () => { this.testImageLoad(callback); };
            // Manage error too to make sure we have a callback
            this.imageFront.onerror = (e) => { this.testImageLoad(callback, e); };
            this.imageLeft.onerror = (e) => { this.testImageLoad(callback, e); };
            this.imageBack.onerror = (e) => { this.testImageLoad(callback, e); };
        });
    }

    testImageLoad(callback: () => void, error?: string | Event): void {
        if (error) console.error('Naker: Fail to add technical file image', error);
        this.imageLoaded++;
        if (this.imageLoaded === 3) {
            // On some devices like mobiles rendering images can take time
            callback();
        }
    }

    private setVariants() {
        const model = this.getModel();
        const variantMeshesMaterialsList = model.getVariantMeshesMaterialsList();
        const variantButtons = variantMeshesMaterialsList.map((v) => {
            const { meshes, decalGeometry } = v;
            const selected = model.getSelectedVariantMeshes(meshes);
            let color = ''; let materialName = 'not selected';
            if (selected && selected.material) {
                const toolM = this.system.toolMaterial;
                color = toolM.getColorFromMaterialKey(selected.material, false, false);
                const material = this.system.toolMaterial.getMaterialByKey(selected.material);
                materialName = material.name;
            }

            const translatedName = this.getMeshesTranslation(meshes);
            let textLabel;
            if (decalGeometry) {
                const patternText = model.getPatternText(meshes);
                const variantText = (patternText) ? patternText.getVariant() as IVariantText : null;
                if (variantText && variantText.text) {
                    textLabel = `"${variantText.text}" (${variantText.font})`;
                } else {
                    // If decal and no text, there is nothing to show
                    return null;
                }
            }
            const button = el('div.naker-menu-mesh', [
                el('div.naker-title', translatedName),
                (textLabel) ? el('div.naker-text', textLabel) : null,
                el('div.naker-combo',
                    el('div.naker-pin', { style: { background: color } })),
                el('div.naker-label', this.getTranslations(materialName)),
            ]);
            return button;
        });
        setChildren(this.variantsContainer, variantButtons);
    }

    private getModel(): ContentModel {
        return this.contentsManager.getFirstModel();
    }

    private getMeshesTranslation(meshes: string[]): string {
        const model = this.getModel();
        const variantMeshes = model.getVariantMeshesPropertiesByMeshes(meshes);
        if (variantMeshes && variantMeshes.nakerName) {
            return this.getTranslations(variantMeshes.nakerName);
        } if (variantMeshes && variantMeshes.meshes) {
            return this.getTranslations(variantMeshes.meshes[0]);
        }
        return '';
    }

    private getTranslations(key: string): string {
        const translations = [];
        this.langages.map((langage) => {
            const trans = this.configurationTranslation.getLangageString(langage, key);
            if (!translations.includes(trans)) translations.push(trans);
            return langage;
        });
        const translationsString = translations.join(' - ');
        return translationsString;
    }
}
